"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCoreError = exports.getErrorTypeChecker = exports.ensureError = exports.WrappedError = exports.ConfigError = void 0;
/** Use internally to raise problem with config. */
class ConfigError extends Error {
    constructor() {
        super(...arguments);
        /** Gets type of error to make cross-boundary error type disambiguation more reliable. */
        this.errorType = 'ConfigError';
    }
}
exports.ConfigError = ConfigError;
/** Wraps given value (usually caught in a try-catch). Recommmend using with `ensureError` to coerce any thrown value to an Error instance. */
class WrappedError extends Error {
    constructor(thrownValue, message) {
        var _a;
        if (!message) {
            message =
                typeof thrownValue === 'string'
                    ? thrownValue
                    : (_a = thrownValue === null || thrownValue === void 0 ? void 0 : thrownValue.message) !== null && _a !== void 0 ? _a : 'Unexpected error. See thrownValue prop for details of what was thrown.';
        }
        super(message);
        this.thrownValue = thrownValue;
        /** Gets type of error to make cross-boundary error type disambiguation more reliable. */
        this.errorType = 'WrappedError';
    }
}
exports.WrappedError = WrappedError;
/** Use to ensure caught value is an Error type. Will wrap non-Error value in `WrappedError`. */
const ensureError = (ex) => (ex instanceof Error ? ex : new WrappedError(ex));
exports.ensureError = ensureError;
const getErrorTypeChecker = () => {
    return (ex, type) => {
        return (ex === null || ex === void 0 ? void 0 : ex.errorType) === type;
    };
};
exports.getErrorTypeChecker = getErrorTypeChecker;
/**
 * Check if given exception/error is of given type (expects errorType to be defined).
 *
 * @param ex - caught exception/error to check
 * @param type - type to check for (should mirrror the class name)
 * @returns
 */
exports.isCoreError = (0, exports.getErrorTypeChecker)();
